var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"myButton",staticClass:"tvb-button",class:[
    ("tvb-button-" + (_vm.type ? _vm.type : 'brightness')),
    {'tvb-button-disabled': _vm.disabled} ],on:{"click":function($event){$event.preventDefault();return _vm.emitClick($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }